import React, { useRef } from 'react';
import IdleTimer from 'react-idle-timer';
import { userService } from '../services';
import { getSessionVariable } from '../helpers';
import { AUTH_TOKEN_NAME, IDLE_TIME_LIMIT } from '../constants';

const IdleTimerContainer = () => {
  const idleTimerRef = useRef(null);
  const idleTimeLimit = IDLE_TIME_LIMIT; // 15 Minutes
  // Trigger when idle time reach to the limit set
  const onIdle = () => {
    if (getSessionVariable(AUTH_TOKEN_NAME)) {
      // Logout user
      userService.logout();
    }
  };
  return (
    <IdleTimer ref={idleTimerRef} timeout={idleTimeLimit} onIdle={onIdle} />
  );
};

export default IdleTimerContainer;
